import { BaseInputProps } from '@components/InputFieldControlled/InputText.types';
import {
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
    Typography,
    styled,
    useTheme,
} from '@mui/material';
import { Controller } from 'react-hook-form';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    marginRight: 0,
    '& .MuiFormControlLabel-label': {
        fontSize: 14,
    },
    '& .MuiRadio-root': {
        padding: '0 9px',
    },
}));

export const GENDERS = {
    female: 'Femme',
    male: 'Homme',
    other: 'Non genré',
};

function InputGender(props: BaseInputProps) {
    const theme = useTheme();

    return (
        <FormGroup
            sx={{
                width: '100%',
                flex: 1,
                ...(props.viewOnly && { maxWidth: 380 }),
            }}>
            <Controller
                name={props.name}
                control={props.control}
                rules={{
                    required: props.required,
                }}
                defaultValue={props.defaultValue}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <>
                        {props.label && (
                            <FormLabel
                                sx={{
                                    color: error
                                        ? theme.palette.errorRed.main
                                        : theme.palette.text.primary,
                                }}>
                                {props.label}
                            </FormLabel>
                        )}
                        {props.viewOnly ? (
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary }}>
                                {value ? GENDERS[value] : '-'}
                            </Typography>
                        ) : (
                            <>
                                <RadioGroup
                                    aria-labelledby="input-gender-label"
                                    onChange={e => onChange(e.target.value)}
                                    value={value ?? ''}
                                    name="radio-buttons-group"
                                    sx={{
                                        flexDirection: 'row',
                                        justifyContent: { xs: 'space-between', sm: 'flex-start' },
                                        gap: { xs: 0, sm: 2 },
                                    }}>
                                    <StyledFormControlLabel
                                        value="female"
                                        control={<Radio name={props.name} checked={value === 'female'} />}
                                        label={
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: error
                                                        ? theme.palette.errorRed.main
                                                        : theme.palette.text.primary,
                                                }}>
                                                {GENDERS.female}
                                            </Typography>
                                        }
                                    />
                                    <StyledFormControlLabel
                                        value="male"
                                        control={<Radio name={props.name} checked={value === 'male'} />}
                                        label={
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: error
                                                        ? theme.palette.errorRed.main
                                                        : theme.palette.text.primary,
                                                }}>
                                                {GENDERS.male}
                                            </Typography>
                                        }
                                    />
                                    <StyledFormControlLabel
                                        value="other"
                                        control={<Radio name={props.name} checked={value === 'other'} />}
                                        label={
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: error
                                                        ? theme.palette.errorRed.main
                                                        : theme.palette.text.primary,
                                                }}>
                                                {GENDERS.other}
                                            </Typography>
                                        }
                                    />
                                </RadioGroup>
                                {error?.message && (
                                    <FormHelperText error>{error.message}</FormHelperText>
                                )}
                            </>
                        )}
                    </>
                )}
            />
        </FormGroup>
    );
}

export default InputGender;
